/** init domain config */
import './config'

import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'
import { VueAxios } from "@/utils/request"

// require('@jeecg/antd-online-mini')
// require('@jeecg/antd-online-mini/dist/OnlineForm.css')

import Antd, { version } from 'ant-design-vue'
// console.log('ant-design-vue version:', version)

import Viser from 'viser-vue'
import 'ant-design-vue/dist/antd.less';  // or 'ant-design-vue/dist/antd.less'

import '@/permission' // permission control
import '@/utils/filter' // base filter
// import Print from 'vue-print-nb-jeecg'
/*import '@babel/polyfill'*/
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
import {
  ACCESS_TOKEN,
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_MULTI_PAGE
} from "@/store/mutation-types"
import config from '@/defaultSettings'

import JDictSelectTag from './components/dict/index.js'
import hasPermission from '@/utils/hasPermission'
import vueBus from '@/utils/vueBus';
// import JeecgComponents from '@/components/jeecg/index'
import '@/assets/less/JAreaLinkage.less'
import VueAreaLinkage from 'vue-area-linkage'
// import '@/components/jeecg/JVxeTable/install'
// import '@/components/JVxeCells/install'
import SSO from '@/cas/sso'
import globalComponent from './register.js'
/*图片预览 https://mirari.cc/ */
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { checkVersion } from '@/version-check'


Vue.config.productionTip = false
Vue.use(Storage, config.storageOptions)
Vue.use(Antd)
Vue.use(VueAxios, router)
Vue.use(Viser)
Vue.use(hasPermission)
Vue.use(JDictSelectTag)
// Vue.use(Print)
 //Vue.use(preview)
Vue.use(vueBus);
// Vue.use(JeecgComponents);
Vue.use(VueAreaLinkage);
Vue.use(globalComponent)
Vue.use(Viewer)
// 默认语言为 en-US，如果你需要设置其他语言，推荐在入口文件全局设置 locale
// import 'moment/dist/locale/zh-cn';

function main() {
  new Vue({
    router,
    store,
    mounted () {
      store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
      // store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, config.navTheme))
      store.commit('TOGGLE_THEME', config.navTheme)
      store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout))
      store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader))
      store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar))
      store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth))
      store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader))
      store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak))
      store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
      store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
      store.commit('SET_MULTI_PAGE',Vue.ls.get(DEFAULT_MULTI_PAGE,true))
    },
    render: h => h(App)
  }).$mount('#app')
}

SSO.init(() => {
  checkVersion();
  main();
});

// 每1分钟检测一次
setInterval(checkVersion, 1 * 60 * 1000);
// main()
// new Vue({
//   router,
//   store,
//   mounted () {
//     store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
//     store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, config.navTheme))
//     store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout))
//     store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader))
//     store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar))
//     store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth))
//     store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader))
//     store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak))
//     store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
//     store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
//     store.commit('SET_MULTI_PAGE',Vue.ls.get(DEFAULT_MULTI_PAGE,config.multipage))
//   },
//   render: h => h(App)
// }).$mount('#app')

// Register new directive
// 注册全局指令
Vue.directive('double-tap', {
  bind(el, binding) {
    let lastTap = 0;
    let timeout;
    
    el.addEventListener('click', (e) => {
      const currentTime = new Date().getTime();
      const tapLength = currentTime - lastTap;
      
      if (tapLength < 300 && tapLength > 0) {
        // 双击
        binding.value.doubleTap && binding.value.doubleTap(e);
        clearTimeout(timeout);
      } else {
        // 单击
        timeout = setTimeout(() => {
          binding.value.singleTap && binding.value.singleTap(e);
        }, 300);
      }
      
      lastTap = currentTime;
    });
  }
});

Vue.directive('all-blur', {
  inserted(el, binding) {
    // 获取所有input元素
    const inputs = el.querySelectorAll('input');
    let isSwitching = false; // 标记是否正在切换输入框

    // 定义事件处理函数
    const handleFocusOut = () => {
      isSwitching = true;
    };

    const handleBlur = () => {
      setTimeout(() => {
        isSwitching = false;
        checkAllBlurred();
      }, 10);
    };

    const handleFocus = () => {
      isSwitching = false;
    };

    const handleDocumentClick = (e) => {
      // 只有当点击的不是input元素时才检查
      if (![...inputs].some(input => input.contains(e.target))) {
        checkAllBlurred();
      }
    };

    // 检查是否所有input都失去焦点
    const checkAllBlurred = () => {
      // 如果正在切换输入框，则不处理
      if (isSwitching) return;
      
      const hasFocus = [...inputs].some(input => 
        input === document.activeElement
      );
      
      if (!hasFocus) {
        binding.value(); // 当所有input都失去焦点时调用回调
      }
    };

    // 为每个input添加事件监听
    inputs.forEach(input => {
      input.addEventListener('focusout', handleFocusOut);
      input.addEventListener('blur', handleBlur);
      input.addEventListener('focus', handleFocus);
    });

    // 添加点击事件监听
    document.addEventListener('click', handleDocumentClick);

    // 保存清理函数
    el._allBlurCleanup = () => {
      inputs.forEach(input => {
        input.removeEventListener('focusout', handleFocusOut);
        input.removeEventListener('blur', handleBlur);
        input.removeEventListener('focus', handleFocus);
      });
      document.removeEventListener('click', handleDocumentClick);
    };
  },

  unbind(el) {
    if (el._allBlurCleanup) {
      el._allBlurCleanup();
    }
  }
});